module.exports = __webpack_public_path__ + "49a506af255cdac4c78b62414d4f8598.jpg";